const iconSizes = {
  lg: {
    height: 48,
    width: 48,
  },
  md: {
    height: 32,
    width: 32,
  },
  m24: {
    height: 24,
    width: 24,
  },
  ms: {
    height: 20,
    width: 20,
  },
  sm: {
    height: 16,
    width: 16,
  },
  xsl: {
    height: 12,
    width: 12,
  },
  xs: {
    height: 8,
    width: 8,
  },
};

export default iconSizes;
